"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useBoostedDrops } from "@/hooks/useBoostedDrops";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useRouter } from "next/navigation";
import { useCallback, useMemo } from "react";
import BoostedDropCardHome from "./BoostedDropCardHome";
const BOOSTED_DROPS_LIMIT = 50;
const MAX_ROWS = 3;
export function BoostedSection() {
  const $ = _c(22);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      limit: BOOSTED_DROPS_LIMIT
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: drops,
    isLoading
  } = useBoostedDrops(t0);
  const isLg = useMediaQuery("(min-width: 1024px)");
  const isSm = useMediaQuery("(min-width: 640px)");
  let t1;
  bb0: {
    if (!drops) {
      let t2;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    if (!isSm) {
      let t2;
      if ($[2] !== drops) {
        t2 = drops.slice(0, 6);
        $[2] = drops;
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t1 = t2;
      break bb0;
    }
    const columns = isLg ? 3 : 2;
    const maxItems = columns * MAX_ROWS;
    let t2;
    if ($[4] !== drops || $[5] !== maxItems) {
      t2 = drops.slice(0, maxItems);
      $[4] = drops;
      $[5] = maxItems;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = t2;
  }
  const visibleDrops = t1;
  let t2;
  if ($[7] !== router) {
    t2 = drop => {
      router.push(`/waves?wave=${drop.wave.id}&serialNo=${drop.serial_no}`);
    };
    $[7] = router;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleDropClick = t2;
  if (isLoading) {
    let t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-top-0 tw-h-px tw-bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.08)_15%,rgba(255,255,255,0.08)_85%,transparent_100%)]" />;
      t4 = <div className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-px tw-bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.08)_15%,rgba(255,255,255,0.08)_85%,transparent_100%)]" />;
      $[9] = t3;
      $[10] = t4;
    } else {
      t3 = $[9];
      t4 = $[10];
    }
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <section className="-tw-mx-8 tw-relative tw-bg-iron-950 tw-px-4 tw-py-16 md:tw-px-6 lg:tw-px-8">{t3}{t4}<div className="tw-relative tw-px-8"><div className="tw-flex tw-h-64 tw-items-center tw-justify-center"><div className="tw-text-sm tw-text-iron-500">Loading...</div></div></div></section>;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  if (!drops || visibleDrops.length === 0) {
    return null;
  }
  let t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-top-0 tw-h-px tw-bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.08)_15%,rgba(255,255,255,0.08)_85%,transparent_100%)]" />;
    t4 = <div className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-px tw-bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.08)_15%,rgba(255,255,255,0.08)_85%,transparent_100%)]" />;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-mb-8"><div className="tw-flex tw-items-center"><span className="tw-m-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-iron-200 md:tw-text-2xl">Boosted Drops</span></div><p className="tw-mb-0 tw-mt-2 tw-text-base tw-text-iron-500">Community-boosted right now</p></div>;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== handleDropClick || $[16] !== visibleDrops) {
    let t7;
    if ($[18] !== handleDropClick) {
      t7 = drop_0 => <div key={drop_0.id}><BoostedDropCardHome drop={drop_0} onClick={() => handleDropClick(drop_0)} /></div>;
      $[18] = handleDropClick;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    t6 = visibleDrops.map(t7);
    $[15] = handleDropClick;
    $[16] = visibleDrops;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[20] !== t6) {
    t7 = <section className="tw-relative tw-bg-iron-950 tw-px-4 tw-py-10 md:tw-px-6 md:tw-py-16 lg:tw-px-8">{t3}{t4}<div className="tw-relative">{t5}<div className="tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-gap-6">{t6}</div></div></section>;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}